import { useEffect } from "react";
import LegalLayout from "./LegalLayout";
import { setPageMeta } from "../lib/seo";

export default function CookiePolicy() {
    useEffect(() => {
        setPageMeta({
            title: "Cookie Policy — TecSuite",
            description:
                "Informativa cookie di tecsuite.it: tipologie di cookie utilizzati, finalità, gestione delle preferenze e riferimenti alle Linee Guida del Garante.",
            canonical: "https://tecsuite.it/cookie",
        });
        window.scrollTo(0, 0);
    }, []);

    return (
        <LegalLayout title="Cookie Policy" updatedAt="04/07/2026">
            <p>
                La presente Cookie Policy descrive le tipologie di cookie e di tecnologie simili
                utilizzati dal sito <strong>tecsuite.it</strong>, le finalità del loro utilizzo e le
                modalità con cui l&apos;utente può gestirli, ai sensi del Regolamento (UE) 2016/679
                (&quot;GDPR&quot;), del D.lgs. 196/2003 e s.m.i. e delle Linee Guida del Garante per
                la Protezione dei Dati Personali del 10 giugno 2021.
            </p>

            <h2>1. Cosa sono i cookie</h2>
            <p>
                I cookie sono piccoli file di testo che i siti visitati inviano al browser
                dell&apos;utente, dove vengono memorizzati per essere ritrasmessi al sito alla visita
                successiva. Le tecnologie simili (web beacon, pixel, local storage) svolgono funzioni
                analoghe di identificazione o memorizzazione di informazioni sul dispositivo.
            </p>

            <h2>2. Tipologie di cookie utilizzati</h2>

            <h3>2.1 Cookie tecnici (non richiedono consenso)</h3>
            <p>
                Sono cookie strettamente necessari al funzionamento del sito, alla navigazione e alla
                fruizione dei servizi richiesti dall&apos;utente. Il loro utilizzo non richiede il
                consenso dell&apos;interessato (art. 122 Codice Privacy).
            </p>
            <ul>
                <li>
                    <strong>Cookie di sessione e navigazione</strong>: garantiscono la normale
                    esperienza di navigazione (persistenza di stato, sicurezza, bilanciamento del
                    carico).
                </li>
                <li>
                    <strong>Cookie di preferenza</strong>: memorizzano scelte tecniche come la lingua
                    o eventuale accettazione della cookie policy.
                </li>
            </ul>

            <h3>2.2 Cookie analytics anonimizzati (equiparati ai tecnici)</h3>
            <p>
                Il sito <strong>non utilizza attualmente</strong> strumenti di analytics con
                profilazione. Qualora venissero introdotti (es. Google Analytics), verranno
                configurati con IP anonimizzato e senza incrocio di dati, come previsto dalle Linee
                Guida del Garante per essere assimilabili a cookie tecnici; in caso contrario sarà
                richiesto il consenso preventivo.
            </p>

            <h3>2.3 Cookie di profilazione e marketing (richiedono consenso)</h3>
            <p>
                Il sito <strong>non utilizza attualmente</strong> cookie di profilazione o
                marketing propri né di terze parti. Se in futuro dovessero essere introdotti,
                l&apos;utente sarà informato tramite banner e potrà prestare, negare o revocare il
                consenso liberamente.
            </p>

            <h3>2.4 Cookie di terze parti</h3>
            <p>
                Il sito può caricare risorse fornite da terze parti (ad esempio font Google) che
                potrebbero utilizzare cookie tecnici per il corretto caricamento delle stesse. Per il
                dettaglio delle policy delle terze parti si rimanda ai rispettivi siti:
            </p>
            <ul>
                <li>
                    Google Fonts — <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer noopener">policies.google.com/privacy</a>
                </li>
            </ul>

            <h2>3. Come gestire i cookie</h2>
            <p>
                L&apos;utente può in qualsiasi momento gestire le proprie preferenze relative ai
                cookie:
            </p>
            <ul>
                <li>
                    <strong>Tramite il proprio browser</strong>, modificando le impostazioni per
                    bloccare o eliminare i cookie. Di seguito i link alle guide dei principali
                    browser:
                </li>
            </ul>
            <ul>
                <li>
                    <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer noopener">Google Chrome</a>
                </li>
                <li>
                    <a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank" rel="noreferrer noopener">Mozilla Firefox</a>
                </li>
                <li>
                    <a href="https://support.apple.com/it-it/HT201265" target="_blank" rel="noreferrer noopener">Apple Safari</a>
                </li>
                <li>
                    <a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noreferrer noopener">Microsoft Edge</a>
                </li>
            </ul>
            <p>
                Si segnala che il blocco dei cookie tecnici può compromettere il corretto
                funzionamento del sito.
            </p>

            <h2>4. Titolare del trattamento</h2>
            <p>
                Il Titolare del trattamento dei dati personali eventualmente raccolti tramite cookie
                è <strong>Tecnologie S.r.l.</strong>, con sede in Viale dell&apos;Industria, 11 —
                37023 Grezzana (VR). Contatti: <a href="mailto:info@tecsuite.it">info@tecsuite.it</a>{" "}
                — tel. <a href="tel:+390454770241">045 4770241</a>.
            </p>

            <h2>5. Diritti dell&apos;interessato</h2>
            <p>
                L&apos;utente può esercitare in ogni momento i diritti previsti dagli artt. 15-22
                GDPR (accesso, rettifica, cancellazione, limitazione, portabilità, opposizione) e
                proporre reclamo all&apos;Autorità Garante per la Protezione dei Dati Personali. Per
                maggiori dettagli si veda la nostra{" "}
                <a href="/privacy">Privacy Policy</a>.
            </p>

            <h2>6. Aggiornamenti</h2>
            <p>
                Il Titolare si riserva il diritto di aggiornare la presente Cookie Policy in caso di
                modifiche normative o dei servizi. Le versioni aggiornate saranno pubblicate su
                questa pagina.
            </p>

            <p className="text-xs text-slate-500 mt-10">
                Nota: il presente testo riflette la configurazione tecnica del sito al momento
                dell&apos;ultimo aggiornamento. In caso di introduzione di nuovi cookie di terze
                parti o di profilazione, verrà attivato un cookie banner con raccolta esplicita del
                consenso e la presente informativa sarà aggiornata di conseguenza.
            </p>
        </LegalLayout>
    );
}
